import React from 'react';
import {
  Box,
  Container,
  Heading,
  SimpleGrid,
  HStack,
  Text,
  Icon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { useAppData } from '../../store/dataStore';

const MotionBox = motion(Box);

const WebinarLearning = ({ data }) => {
  const { appData } = useAppData();
  const { studentsCount } = appData;

  // Safety check
  const componentData = data || {
    title: "What You'll Learn",
    subtitle: "Everything you need to start your AI career journey",
    topics: [],
    icons: {}
  };

  return (
    <Box py={{ base: 16, md: 24 }} bg="white">
      <Container maxW="container.xl">
        <MotionBox
          textAlign="center"
          mb={12}
          initial={{ y: 20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <Heading
            as="h2"
            fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
            color="brand.700"
            fontFamily="heading"
            mb={4}
          >
            {componentData.title}
          </Heading>
          <Text fontSize={{ base: 'lg', md: 'xl' }} color="brand.500" maxW="2xl" mx="auto">
            {componentData.subtitle}
          </Text>
        </MotionBox>

        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6} maxW="4xl" mx="auto">
          {componentData.topics.map((topic, index) => (
            <MotionBox
              key={index}
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <HStack
                bg="brand.50"
                p={6}
                borderRadius="xl"
                spacing={4}
                _hover={{ bg: 'accent.silver', transform: 'translateX(8px)' }}
                transition="all 0.3s"
              >
                <Icon
                  as={componentData.icons.check}
                  boxSize={6}
                  color="accent.green"
                  flexShrink={0}
                />
                <Text
                  fontSize={{ base: 'md', md: 'lg' }}
                  fontWeight="500"
                  color="brand.700"
                >
                  {topic}
                </Text>
              </HStack>
            </MotionBox>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WebinarLearning;